import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { sortByProperties } from 'donor-elf-web/lib/array-utils';
import type { onJournalCellChangeCallback } from 'donor-elf-web/lib/journal-utils';
import JournalContactInfo from 'donor-elf-web/lib/models/journal-contact-info';
import ContactsCache from 'donor-elf-web/services/contacts-cache';

interface ComponentArgs {
  journalContactInfo: JournalContactInfo;
  allSegments: string[];
  onGroupClicked: (groupName: string) => void;
  onSegmentClicked: (segmentName: string) => void;
  onChange: onJournalCellChangeCallback;
}

export default class JournalContactDropdownComponent extends Component<ComponentArgs> {
  @service declare contactsCache: ContactsCache;

  @tracked saveError?: any;

  get allGroups() {
    return this.contactsCache.sortedGroups;
  }

  get recommendedContacts() {
    return sortByProperties(
      this.args.journalContactInfo.recommendedContactIds?.map(
        (x) => this.contactsCache.contactsById[x],
      ),
      ['name'],
    );
  }

  get recommendedByContacts() {
    return sortByProperties(
      this.args.journalContactInfo.recommendedByContactIds?.map(
        (x) => this.contactsCache.contactsById[x],
      ),
      ['name'],
    );
  }

  @action
  async saveSelectedJournalSegments(dropdown: any, selectedSegments: string[]) {
    this.saveError = undefined;
    let journalContact = this.args.journalContactInfo.journalContact;
    dropdown.actions.close();
    let previousSegments = journalContact.segments;
    journalContact.segments = selectedSegments;
    try {
      await journalContact.save();
      this.args.onChange({ contactSegmentsChanged: true });
    } catch (error) {
      this.saveError = error;
      journalContact.segments = previousSegments;
    }
  }

  @action
  async saveSelectedGroups(dropdown: any, selectedGroups: string[]) {
    this.saveError = undefined;
    let contact = this.args.journalContactInfo.contact;
    dropdown.actions.close();
    let previousGroups = contact.groups;
    contact.groups = selectedGroups;
    try {
      await contact.save();
      this.args.onChange();
    } catch (error) {
      this.saveError = error;
      contact.groups = previousGroups;
    }
  }
}
